import { W as WuiGraphIcon$1, d as defineCustomElement$1 } from './graph-icon.js';

const WuiGraphIcon = WuiGraphIcon$1;
const defineCustomElement = defineCustomElement$1;

export { WuiGraphIcon, defineCustomElement };

//# sourceMappingURL=wui-graph-icon.js.map